import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { FormularioService, GlobalFormGroup } from '@app/services/formulario';
import { GeneralBreadCrumb } from '../general-template';

@Component({ standalone: false, selector: 'app-general-form',
  templateUrl: 'general-form.component.html',
  styleUrls: ['../general-template.scss','./general-form.component.scss'],
})
export class GeneralFormComponent<T> {
  @Input() breadcrumbs: GeneralBreadCrumb[] = [];
  @Input() title: string = '';
  @Input() loading = true;
  @Input() saving = false;
  @Input() isError = false;
  @Input() errorMessage: string | null = null;
  @Input() form: GlobalFormGroup<T>
  @Input() formTemplate: TemplateRef<any>;
  @Input() footerLeft: TemplateRef<any>;
  @Input() disableSave = false;
  @Input() showReloadOnError = false;

  @Output() save = new EventEmitter<T>();
  @Output() cancel = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  constructor(private readonly formularioService: FormularioService) {}
  onSave() {
    if(!this.formularioService.validarCampos(this.form)) return;
    this.save.emit(this.form.getRawValue());
  }
  onCancel() {
    this.cancel.emit();
  }
  onReload() {
    this.reload.emit();
  }
}
